import { apiStatuses } from './constants';
import { handleGtmErrors } from './handle-gtm-errors';
import { IResponse } from './types';

export type RequestMethodT = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';

const fetchApi = <T>(
  url: string,
  method: RequestMethodT,
  params?: object,
  data?: T,
  noCors?: boolean
) => {
  const apiUrl = new URL(url as string);
  apiUrl.search = new URLSearchParams(params as URLSearchParams).toString();
  let accessToken: string | null = '';

  try {
    accessToken =
      JSON.parse(window.localStorage.getItem('accessToken') || '') ||
      JSON.parse(window.sessionStorage.getItem('accessToken') || '');
  } catch {}

  const request = fetch(apiUrl.href, {
    method,
    ...(!noCors && {
      cache: 'no-cache',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Origin': apiUrl.origin,
        Authorization: `Bearer ${accessToken || null}`,
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
    }),
    body: JSON.stringify(data),
  });

  return request.then(async (response) => {
    const contentType = response.headers.get('content-type');
    const { status } = response;
    const responseData: IResponse<any> = {
      data: null,
      status,
    };
    if (response.redirected && response.status !== apiStatuses.NOT_FOUND) {
      window.location.href = response.url;
    } else if (contentType) {
      if (contentType.includes('application/json')) {
        responseData.data = await response.json();
      } else if (contentType.includes('text/html')) {
        responseData.data = await response.text();
      }
      handleGtmErrors(responseData.data?.id);
    }
    return responseData;
  });
};

export const api = {
  get: <T>(url: string, params?: object, noCors?: boolean) =>
    fetchApi<T>(url, 'GET', params, undefined, noCors),
  post: <T>(url: string, data: T, params?: object) =>
    fetchApi<T>(url, 'POST', params, data),
  patch: <T>(url: string, data: T, params?: object) =>
    fetchApi<T>(url, 'PATCH', params, data),
  put: <T>(url: string, data: T, params?: object) =>
    fetchApi<T>(url, 'PUT', params, data),
};
